import React, { Component } from 'react';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import './ToggleSlider.less';

const LOCALE_PREFIX = 'GB/pages/CAPage/CompletePopup';

export class ToggleSlider extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        checked: PropTypes.bool.isRequired,
        toggle: PropTypes.func.isRequired,
        id: PropTypes.string.isRequired,
        // Below prop come from Field HOC
        input: PropTypes.object.isRequired,

    };

    render() {
        const { intl, checked, toggle, id, input } = this.props;

        return (
            <div id="ToggleSlider" className="direct-debit-toggle clearfix">
                <h3 className="delta">
                    <FormattedMessage id={`${LOCALE_PREFIX}.directDebitLabel`} />
                </h3>
                <label id="directDebitToggle" className="toggle-switch">
                    <input
                        {...input}
                        id={id}
                        className="trackLink"
                        type="checkbox"
                        checked={checked}
                        onClick={toggle}
                    />
                    <div className="slider" aria-hidden="true">
                        <div className="slider-active-bg" />
                        <span className="slider-inactive">
                            {intl.formatMessage({ id: `${LOCALE_PREFIX}.inactiveLabel` })}
                        </span>
                        <span className="slider-active">
                            {intl.formatMessage({ id: `${LOCALE_PREFIX}.activeLabel` })}
                        </span>
                    </div>
                </label>
            </div>
        );
    }
}

export default injectIntl(ToggleSlider);

